import { render, staticRenderFns } from "./ReactivationCampaignBuilder.vue?vue&type=template&id=88821ac2&scoped=true&"
import script from "./ReactivationCampaignBuilder.vue?vue&type=script&lang=js&"
export * from "./ReactivationCampaignBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ReactivationCampaignBuilder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReactivationCampaignBuilder.vue?vue&type=style&index=1&id=88821ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88821ac2",
  null
  
)

export default component.exports